Vue.component('notifications', {
	delimiters: [ '[[', ']]' ],
	mixins: [ eventHubMixin ],
	data: () => {
		return {
			notifications: []
		};
	},
	methods: {
		addAlertSuccess(message) {
			this.notifications.push({
				message: message,
				icon: '👍'
			});
			// this.removeAlertTimeout();
		},
		addAlertError(notification) {
			if (!this.notifications.some((el) => el.message === notification.notification)) {
				this.notifications.push({
					classes: 'is-active is-danger',
					message: notification.notification
				});
				// this.removeAlertTimeout();
			}
		},
		removeAlertTimeout() {
			// let to = setTimeout(() => {
				this.notifications.shift();
				// clearTimeout(to);
			// }, 6000);
		},
		closeNotification(notification) {
			this.notifications.splice(this.notifications.indexOf(notification), 1);
		}
	},
	mounted() {
		this.eventHub.$on('notifications:success', (event) => {
			this.addAlertSuccess(event);
		});
		this.eventHub.$on('notifications:error', (event) => {
			this.addAlertError(event);
		});
	},
	computed:{
		notif_title() {
			return gettext('Attention !');
		},
		notif_close() {
			return gettext('J\'ai vu ce message');
		},
	},
	template: `<ul class="notifications-container" :class="{ 'is-active' : notifications.length > 0 }">
    <transition-group name="tsn-slide-fade" tag="li">
    <li class="notification" :class="notification.classes" v-cloak v-for="(notification, index) in notifications" :key="index">
        <p class="notification-title">[[notif_title]]</p>
  		<p>[[notification.message]]</p>
        <div class="text-center mt-15">
            <button class="btn is-primary is-small" @click="closeNotification(notification)">[[notif_close]]</button>
        </div>
    </li>
    </transition-group>
</ul>
`
});
